export const environment = {
  production: false,
  basePath: 'https://newbraunfelsexpressdevapi.mi2.in/api',
  v1basePath: 'https://newbraunfelsexpressdevapi.mi2.in/api',
  tenant: 'T00001',
  supportedCountry: ['IN', 'US', 'UK'],
  fareFileId: '0fb45d68d58343f89da3776f77ee4068.csv',
  scheduleFileId: 'd8ded8e7d1134687867698fffd32acb5.csv',
};
// https://newbraunfelsexpressdevapi.mi2.in
// https://uildevapi.mi2.in/api